import { z } from 'zod'

export const meResponseSchema = z.object({
  sub: z.string(),
  username: z.string(),
  groups: z.array(z.string()),
})
export type MeResponse = z.infer<typeof meResponseSchema>
